export const ONBOARDING_FEATURE_FLAG_NAME = 'enableOnboarding';
export const ONBOARDING_ENABLED = 'enable_onboarding';
